var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _polygon, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoftwareag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2093.95 425.2",
    style: {
      enableBackground: "new 0 0 2093.95 425.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 212.5981,
    x2: 343.8643,
    y2: 212.5981
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8E3CF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3CC1B7"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M186.87,176.66C131.27,162.29,80.2,144.13,80.2,80.2H0c0,119.92,78.31,148.29,156.99,168.34    c55.61,14.38,106.68,27.33,106.68,96.46h80.2C343.86,224.04,264.42,196.71,186.87,176.66z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.69,425.2h118.03c44.26,0,80.95-34.05,80.95-80.2H64.69V425.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.8,0H161.15C116.89,0,80.2,34.05,80.2,80.2h198.6V0z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M523.1,231.51c-32.15-4.92-45.02-12.48-45.02-23.45c0-10.97,14.38-16.64,28.75-16.64   c15.51,0,32.15,8.32,40.1,23.83l35.56-21.94c-14-27.24-38.21-41.99-75.66-41.99c-38.59,0-71.88,23.45-71.88,58.26   c0,32.91,23.45,51.45,63.93,57.5c30.64,4.92,43.5,11.35,43.5,23.83c0,10.59-12.1,18.54-31.78,18.54   c-19.29,0-34.8-13.24-41.61-28.37l-39.72,21.94c11.35,28.75,41.99,46.53,80.2,46.53c43.5,0,76.79-21.94,76.79-60.15   C586.27,252.32,561.68,237.57,523.1,231.51z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M703.26,151.32c-57.88,0-100.62,41.23-100.62,99.11s42.75,99.11,100.62,99.11c58.26,0,101-41.23,101-99.11   S761.52,151.32,703.26,151.32z M703.26,308.68c-32.53,0-55.99-23.83-55.99-58.26s23.45-58.26,55.99-58.26   c32.53,0,56.37,23.83,56.37,58.26S735.79,308.68,703.26,308.68z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1823.48,151.32c-57.88,0-97.6,41.23-97.6,99.11s39.72,99.11,97.6,99.11c42.37,0,66.2-14.38,85.11-38.59   l-34.05-25.35c-11.35,14.75-26.1,24.59-51.07,24.59c-29.13,0-49.18-18.91-53.34-47.29h148.67v-16.27   C1918.81,190.66,1880.22,151.32,1823.48,151.32z M1772.41,226.97c7.57-22.7,25.72-37.83,51.07-37.83   c27.24,0,45.02,17.02,50.69,37.83H1772.41z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1973.28,155.85l-30.26,73.39h17.02l6.43-16.64h29.51l6.43,16.64h17.02l-30.26-73.39H1973.28z M1971.77,198.98   l9.46-24.97l9.46,24.97H1971.77z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1022.29,99.87h-43.12v55.99h-20.05h-69.6v-35.18h52.2V80.2h-54.1c-26.48,0-41.23,14.38-41.23,40.48v35.18   h-39.34v40.48h39.34V345h43.12V196.33h69.6h20.05v107.81c0,26.48,14.38,40.86,41.23,40.86h54.85v-40.86h-52.96V196.33h52.96v-40.48   h-52.96V99.87z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2054.61,190.66v12.11h23.45c-2.65,7.57-8.32,13.62-19.29,13.62c-13.62,0-22.7-10.59-22.7-23.83   c0-13.24,9.46-23.83,22.32-23.83c9.84,0,15.51,4.54,18.91,9.84l12.48-8.32c-5.68-9.46-16.65-15.51-31.4-15.51   c-21.18,0-37.07,17.02-37.07,37.83c0,20.81,15.13,37.83,37.07,37.83c21.18,0,35.56-14.75,35.56-35.56v-4.16H2054.61z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1604.79,196.71V345h43.12V196.71h71.5v-40.86h-73.39C1619.16,155.85,1604.79,170.23,1604.79,196.71z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1292.77,282.58 1257.21,155.85 1206.52,155.85 1170.96,282.58 1136.15,155.85 1089.25,155.85    1145.99,345 1192.9,345 1231.86,207.68 1270.82,345 1317.73,345 1374.48,155.85 1327.95,155.85  "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1527.84,176.66c-10.59-15.13-30.26-25.35-56.74-25.35c-54.85,0-94.19,40.86-94.19,99.11   s39.34,99.11,94.19,99.11c29.13,0,46.15-11.73,56.74-26.1V345h43.12V155.85h-43.12V176.66z M1475.63,309.06   c-32.15,0-54.47-23.45-54.47-58.64s22.32-58.63,54.47-58.63c32.16,0,54.48,23.45,54.48,58.63S1507.79,309.06,1475.63,309.06z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareag);
export default __webpack_public_path__ + "static/media/softwareag.2013186541abbeae817edde612f0070e.svg";
export { ForwardRef as ReactComponent };